// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { xBaseTheme } from "@synd/XDL/types";
import { getSystemColor } from "@synd/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        mergeCss: true,
        color: "text.link",
        hoverStyle: {
            color: getSystemColor("common.ui10"),
        },
        typographyProps: {
            ...fontConfig.regular,
            weight: fontConfig.weight.medium,
            css: css`
                letter-spacing: 0;
            `,
        },

        css: css`
            & ${IconWrapper} {
                transition: all 0s;
            }
            &[disabled] {
                cursor: not-allowed;

                & ${TypographyStyle} {
                    opacity: 0.44;
                }
                & ${IconWrapper} {
                    opacity: 0.44;
                }
                &:hover {
                    color: inherit;
                    ${IconWrapper} {
                        opacity: 0.44;
                    }
                }
            }
        `,
    },
} as xBaseTheme["link"];
